import { Point } from "pixi.js";
import { ObjectFieldsChecker } from "../../../../../tools/ObjectFieldsChecker";
import { UserLevelUpDto } from "../../../../networking/data/responses/upgrade/UserLevelUpDto";
import { IUserLevelUpModel } from "./IUserLevelUpModel";
import { PlayerDto } from "by/gamefactory/cityversetycoon/networking/data/responses/user/PlayerDto";
import { PiggyBankDto } from "by/gamefactory/cityversetycoon/networking/data/responses/piggybank/PiggyBankDto";

export class UserLevelUpModel implements IUserLevelUpModel {
    public readonly rewardInCoins: number;
    public readonly additionalRaidStealRewardPercentage: number;
    public readonly additionalWheelRewardPercentage: number;
    public readonly openedPiggyBank: PiggyBankDto;
    public readonly playerDto: PlayerDto;
    private avatarPositionYProperty: Point;
    public get avatarPosition(): Point {
        return this.avatarPositionYProperty;
    }

    public set avatarPosition(value: Point) {
        this.avatarPositionYProperty = value;
    }

    public constructor(dto: UserLevelUpDto, playerDto: PlayerDto) {
        ObjectFieldsChecker.throwIfInvalidFields(dto, ["rewardInCoins", "additionalRaidRewardPercentage", "additionalWheelRewardPercentage"]);
        this.rewardInCoins = dto.rewardInCoins;
        this.additionalRaidStealRewardPercentage = dto.additionalRaidRewardPercentage;
        this.additionalWheelRewardPercentage = dto.additionalWheelRewardPercentage;
        this.openedPiggyBank = dto.openedPiggyBank;
        this.playerDto = playerDto;
    }
}
